var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMeadowModalBg1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 612,
    height: 382,
    viewBox: "0 0 612 382",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7188_91429)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M516.091 36.7175L506.369 43.9802L512.279 33.5751L493.27 17.9026L412.041 36.6314L421.684 46.5698L401.26 39.1173L295.241 63.562L262.597 36.7583L255.16 47.3129L258.546 33.4321L230.008 10L209.766 29.3901L211.088 38.8186L207.231 31.8189L174.094 63.562L131.576 37.22L116.799 50.737L123.364 61.216L112.978 54.2325L93.4556 72.0917L52.9463 37.22L18 74.8514V281.513L29.5 288.998H18V340.466L179.5 363.5L383.572 344.03L377.683 328.421L392.17 340.878L530.546 312L601 229.126L530.546 251V174.5L519 181.5L530.546 163V48.6349L516.091 36.7175Z",
    fill: "black",
    fillOpacity: 0.4,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.091 36.7175L506.369 43.9802L512.279 33.5751L493.27 17.9026L412.041 36.6314L421.684 46.5698L401.26 39.1173L295.241 63.562L262.597 36.7583L255.16 47.3129L258.546 33.4321L230.008 10L209.766 29.3901L211.088 38.8186L207.231 31.8189L174.094 63.562L131.576 37.22L116.799 50.737L123.364 61.216L112.978 54.2325L93.4556 72.0917L52.9463 37.22L18 74.8514V281.513L29.5 288.998H18V340.466L179.5 363.5L383.572 344.03L377.683 328.421L392.17 340.878L530.546 312L601 229.126L530.546 251V174.5L519 181.5L530.546 163V48.6349L516.091 36.7175Z",
    stroke: "black",
    strokeOpacity: 0.2,
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7188_91429",
    x: 0.5,
    y: 0.332031,
    width: 610.996,
    height: 380.671,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7188_91429"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7188_91429",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeadowModalBg1);
export default __webpack_public_path__ + "static/media/meadow-modal-bg-1.3daf3922a92a4c580b492070ece0b75f.svg";
export { ForwardRef as ReactComponent };